import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, NgForm, FormBuilder, Validators } from '@angular/forms';
import { UserRegistrationService } from '../service/cognito.service';
import { AuthService } from '../service/auth.service';
import { Router } from '@angular/router';
import { RegistrationUser } from '../user';
import { BackEndRegistration } from '../user';

import { StripeService, StripeCardComponent, ElementOptions, ElementsOptions } from 'ngx-stripe';
import { TranslateService } from '@ngx-translate/core';
import { GlobalEventsManager } from '../../app-global-events-manager';

// jQuery Sign $
declare let $: any;

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  invalidValidationMsg: string;
  user: RegistrationUser = new RegistrationUser();
  registerUser: BackEndRegistration = new BackEndRegistration();
  // tslint:disable-next-line:no-inferrable-types
  isFirstStep: boolean = true;
  // tslint:disable-next-line:no-inferrable-types
  isSecondStep: boolean = false;
  // tslint:disable-next-line:no-inferrable-types
  isThirdStep: boolean = false;
  // tslint:disable-next-line:no-inferrable-types
  isFourthStep: boolean = false;
  isfifthStep: boolean;
  isRegisteredCompany: boolean;
  isregistered: string;
  address: any = {
    streetname: '',
    zipcode: '',
    city: '',
    state: ''
  };
  loaderActivate: boolean;
  agreementfilter: boolean;
  // tslint:disable-next-line:no-inferrable-types
  agreementagreed: string = 'No';
  @ViewChild('termsandconditions') openTermsAndConditionModal: ElementRef;
  // stripe Implementation
  @ViewChild('paymentprocess') paymentprocess: NgForm;
  @ViewChild(StripeCardComponent) card: StripeCardComponent;
  paymentInformation: any = {
    payment_method: 'Invoice'
  };
  stripeTokenId: string;

  cardOptions: ElementOptions = {
    style: {
      base: {
        iconColor: '#666EE8',
        color: '#31325F',
        lineHeight: '40px',
        fontWeight: 300,
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSize: '18px',
        '::placeholder': {
          color: '#CFD7E0'
        }
      }
    }
  };

  elementsOptions: ElementsOptions = {
    locale: 'en'
  };
  isValidationFirst: boolean;
  isValidationSecond: boolean;
  isValidationThird: boolean;
  isValidationFourth: boolean;
  isValidationFiveth: boolean;
  @ViewChild('saveinfomrationform') reportworkerform: NgForm;

  constructor(private authService: AuthService, private router: Router,
    public userRegistrationService: UserRegistrationService, private fb: FormBuilder,
    private stripeService: StripeService, private translate: TranslateService,  private globalEventsManager: GlobalEventsManager) {
  }
  verificationForm = new FormGroup({
    verficationCode: new FormControl()
  });

  ngOnInit() {
    this.isregistered = '';
    this.globalEventsManager.showNavBarSeller(false);
    this.globalEventsManager.showNavBarWorker(false);
    this.globalEventsManager.showNavBar(false);
  }

  // Checking Email Exists or Not
  checkemailValidation(event: any) {
    this.invalidValidationMsg = null;
    // without type info
    if (event.target.value !== undefined && event.target.value !== null && event.target.value !== '') {
      this.user.email = event.target.value;
      this.authService.checkUserNameExitsOrNot(this.user.email).subscribe(res => {
        if (res) {
          this.translate.get('Register.EmailExists').subscribe(error => {
            this.invalidValidationMsg = error;
          });
          // this.invalidValidationMsg = 'Already Exits the email';
        }
      }, err => {
        console.log(err);
        // this.invalidValidationMsg = 'Already Exits the email';
      });
    }
  }

  // Moving from First Step
  registrationStep1NextLevel(model: any, isValid: boolean): void {
    if (!isValid) {
      return;
    }
    this.isregistered = '';
    this.loaderActivate = true;
    this.authService.getbussinessInfomation(model.company_registration_no).finally(() => {
       this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        if (res === -9) {
          this.translate.get('Register.Alreadyregistered').subscribe(error => {
            this.isregistered = error;
          });
          // this.isregistered = 'Already registered';
        } else if (res === -3) {
          this.translate.get('Register.Companyregnoisnotavailable').subscribe(error => {
            this.isregistered = error;
          });
         // this.isregistered = 'Company reg no is not available';
        } else {
          this.isValidationFirst = true;
          this.registerUser.company_registration_no = res.company_registration_no;
          this.registerUser.company_name = res.company_name;
          this.address.streetname = res.street_address;
          this.address.city = res.city;
          this.address.zipcode = res.zip_code;
          this.address.state = res.state;
          if (res.f_tax_registration === 1) {
            this.isRegisteredCompany = true;
            this.isFirstStep = false;
            this.isSecondStep = true;
          } else {
            this.isRegisteredCompany = false;
            this.isregistered = '';
            // this.isregistered = 'Number not regsitered for F-Tax';
            this.translate.get('Register.NumbernotregsiteredforFTax').subscribe(error => {
              this.isregistered = error;
            });
          }
        }
      }
    }, err => {
      console.log(err);
    });
  }
  // Moving From Second Step
  registrationStep2NextLevel(model: any, isValid: boolean): void {
    this.invalidValidationMsg = '';
    if (!isValid) {
      return;
    }
    this.isFirstStep = false;
    this.isSecondStep = false;
    this.isfifthStep = false;
    this.isThirdStep = true;
    this.isValidationSecond = true;
  }
  // Moving from Third Step
  registrationStep3NextLevel(model: any, isValid: boolean): void {
    this.invalidValidationMsg = '';
    if (!isValid) {
      return;
    }
    this.isFirstStep = false;
    this.isSecondStep = false;
    this.isThirdStep = false;
    this.isfifthStep = false;
    this.isFourthStep = true;
    this.isValidationThird = true;
  }

  // Cognito Call Back after Call registration Page
  cognitoCallback(message: string, result: any) {
    if (message != null) { // error
       this.invalidValidationMsg = message;
      // this.translate.get('Register.NumbernotregsiteredforFTax').subscribe(error => {
      //   this.invalidValidationMsg = error;
      // });
      this.loaderActivate = false;
      console.log('result: ' + this.invalidValidationMsg);
      if (this.invalidValidationMsg === 'User is not confirmed.') {
        console.log('redirecting');
      }
    } else { // success
      this.loaderActivate = false;
      this.isFirstStep = false;
      this.isSecondStep = false;
      this.isThirdStep = false;
      this.isFourthStep = true;
      this.isValidationFourth = true;
      // this.authService.backEndRegistration(this.registerUser).finally(() => {
      //   this.loaderActivate = false;
      // }).subscribe(res => {
      //   if (res != null) {
      //     this.isFirstStep = false;
      //     this.isSecondStep = false;
      //     this.isThirdStep = false;
      //     this.isFourthStep = true;
      //   }
      // }, err => {
      //   console.log(err);
      // });

    }
  }

  onFilterChange(eve: any) {
    if (eve) {
     // this.agreementagreed = 'Yes';
      // this.agreementfilter = true;
      $(this.openTermsAndConditionModal.nativeElement).modal('show');
    }else {
      this.agreementagreed = 'No';
      this.agreementfilter = false;
    }
  }

  // Decline Terms and Condition
  declineTermsandcondition(): void {
    this.reportworkerform.form.get('agreementfilter').setValue(false);
    this.agreementagreed = 'No';
    $(this.openTermsAndConditionModal.nativeElement).modal('hide');
  }

  // Accept the terms and conditions
  acceptTermsandcondition(): void {
    this.agreementfilter = true;
    this.agreementagreed = 'Yes';
    this.invalidValidationMsg = '';
    $(this.openTermsAndConditionModal.nativeElement).modal('hide');
  }

  // Registration step 4
  registrationStep4CreditCardInformation(model: any, isValid: boolean) {
    this.invalidValidationMsg = '';
    // call API to save customer
    if (!isValid) {
     // this.invalidValidationMsg = 'All fields are required';
        this.translate.get('Register.Allfieldsrequired').subscribe(error => {
        this.invalidValidationMsg = error;
      });
      return;
    }

    if (this.invalidValidationMsg === 'Already Exits the email') {
      return;
    }

    this.isFirstStep = false;
    this.isSecondStep = false;
    this.isThirdStep = false;
    this.isfifthStep = false;
    this.isFourthStep = true;

  }

  // validate Token
  getCardIdValidation(): boolean {
    if (this.stripeTokenId != null && this.stripeTokenId !== '') {
      return true;
    }
    return false;
  }

  // get the Stripe Key and Create a account for stripe
  getTokenFromStripe(model: any, isValid: boolean) {
    this.invalidValidationMsg = '';
    this.stripeTokenId = '';
    if (!isValid) {
      // this.invalidValidationMsg = 'All fields are required';
      return;
    }
    const name = this.paymentInformation.cardholdername;
    this.stripeService
      .createToken(this.card.getCard(), { name })
      .subscribe(result => {
        if (result.token) {
          // Use the token to create a charge or a customer
          // https://stripe.com/docs/charges
          // console.log(result.token.id);
          this.stripeTokenId = result.token.id;
        } else if (result.error) {
          // Error creating the token
          console.log(result.error.message);
          this.invalidValidationMsg = result.error.message;
        }
      });
  }

  // Save Registration Part
  save(model: BackEndRegistration, isValid: boolean) {
    this.invalidValidationMsg = '';
    // call API to save customer
    if (!isValid) {
      // this.invalidValidationMsg = 'All fields are required';
      this.translate.get('Register.Allfieldsrequired').subscribe(error => {
        this.invalidValidationMsg = error;
      });
      return;
    }
    if (!this.agreementfilter) {
     // this.invalidValidationMsg = 'Please accept the terms and conditions';
     this.translate.get('Register.Pleaseaccepttermsconditions').subscribe(error => {
      this.invalidValidationMsg = error;
    });
      return;
    }

    this.registerUser.address = this.address.streetname + ',' + this.address.zipcode + ',' + this.address.city + ',' + this.address.state;
    this.registerUser.last_name = '';
    this.invalidValidationMsg = null;
    this.registerUser.stripe_source_token = this.stripeTokenId;
    this.loaderActivate = true;
    localStorage.removeItem('verificationUserName');
    localStorage.setItem('verificationUserName', this.registerUser.username);
    this.authService.backEndRegistration(this.registerUser).finally(() => {
     this.loaderActivate = false;
    }).subscribe(res => {
      if (res === 200 || res == null) {
        this.user.firstname = this.registerUser.first_name;
        this.user.lastname = this.registerUser.last_name;
        this.user.email = this.registerUser.username;
        this.user.password = this.registerUser.password;
        this.isFirstStep = false;
        this.isSecondStep = false;
        this.isThirdStep = false;
        this.isFourthStep = false;
        this.isfifthStep = true;
        // this.userRegistrationService.register(this.user, this);
        this.invalidValidationMsg = '';

      } else if (res === 'InvalidPasswordException') {
        this.isFirstStep = false;
        this.isSecondStep = false;
        this.isThirdStep = true;
        this.isFourthStep = false;
        this.isfifthStep = false;
        this.translate.get('Register.InvalidPassword').subscribe(error => {
          this.invalidValidationMsg = error;
        });
        // this.invalidValidationMsg = 'Invalid Password(min - 6 characters,upppercase, lowercase and special character).';
      } else if (res === 'InternalErrorException') {
        this.invalidValidationMsg = 'This exception is thrown when Back end encounters an internal error.';
      } else if (res === 'CodeDeliveryFailureException') {
        this.invalidValidationMsg = 'when a verification code fails to deliver successfully.';
      } else if (res === 'NotAuthorizedException') {
        this.invalidValidationMsg = 'This exception is thrown when a user is not authorized.';
      } else if (res === 'InvalidParameterException') {
        this.invalidValidationMsg = 'Invalid Parameter.';
      }else {
        this.invalidValidationMsg = 'Invalid Parameter.';
        console.log(res);
      }


    }, err => {
      console.log(err);
      this.loaderActivate = false;
    });


    // this.invalidValidationMsg = null;
    // this.loaderActivate = true;
    // localStorage.removeItem('verificationUserName');
    // localStorage.setItem('verificationUserName', this.registerUser.username);


  }

  // Verification Called
  onFormSubmit() {
    this.invalidValidationMsg = '';
    // tslint:disable-next-line:prefer-const
    let verificationcode = this.verificationForm.get('verficationCode').value;
    if (verificationcode == null) {
      this.translate.get('Register.VerificationCoderequired').subscribe(error => {
        this.invalidValidationMsg = error;
      });
     // this.invalidValidationMsg = 'Verification Code is required';
      return;
    }
    this.loaderActivate = true;
    this.authService.confirmEmailVerification(this.registerUser.username, verificationcode).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res === 200) {
        this.router.navigate(['/login']);
        this.loaderActivate = false;
        this.CallBackendVerfication(this.registerUser.username);
      } else if (res === 'CodeMismatchException') {
        this.invalidValidationMsg = 'Ogiltigt verifikation kod.';
      }else if (res === 'ExpiredCodeException') {
        this.invalidValidationMsg = 'Ogiltigt verifikation kod.';
      }else if (res === 'UserNotFoundException') {
        this.invalidValidationMsg = 'User coudnot found.';
      } else {
        this.invalidValidationMsg = 'Ogiltigt verifikation kod.';
      }

    }, err => {
      console.log(err);
      this.invalidValidationMsg = 'Ogiltigt verifikation kod.';
    });
    // this.userRegistrationService.confirmRegistration(this.registerUser.username, verificationcode, this);
  }

  // Call the Cognito Verification Call Back
  cognitoVerificationCallback(message: string, result: any) {
    if (message != null) { // error
      this.loaderActivate = false;
      this.invalidValidationMsg = message;
    } else { // success
      this.router.navigate(['/login']);
      this.loaderActivate = false;
      this.CallBackendVerfication(this.registerUser.username);
    }
  }

  // Call Back end For Verify the Email Address
  CallBackendVerfication(params: string) {
    this.authService.active_User(params).subscribe(res => {
      if (res != null) {
        console.log('successfully activated the user');
      }
    }, err => {
      console.log(err);
    });
  }

  // Call Resend Option
  reSendVerificationCode(): void {
    // tslint:disable-next-line:prefer-const
    // let verifcationEmail = localStorage.getItem('verificationUserName');
    // this.userRegistrationService.resendCode(this.registerUser.username, this);

    this.authService.resendEmailVerification(this.registerUser.username).subscribe(res => {
      if (res === 200) {
        // this.invalidValidationMsg = 'Successfully Resend Code.';
        this.translate.get('Register.SuccessfullyResendCode').subscribe(error => {
          this.invalidValidationMsg = error;
        });
      } else if (res === 'CodeDeliveryFailureException') {
        this.invalidValidationMsg = 'when a verification code fails to deliver successfully.';
      }else if (res === 'UserNotFoundException') {
        this.invalidValidationMsg = 'User is not found.';
      }else if (res === 'InternalErrorException') {
        this.invalidValidationMsg = 'Internal Server Error.';
      }else if (res === 'InvalidParameterException') {
        this.invalidValidationMsg = 'Invalid Parameter.';
      }else {
        this.invalidValidationMsg = 'when a verification code fails to deliver successfully.';
      }
    }, err => {
      this.invalidValidationMsg = err;
      console.log(err);
    });
  }

  // Call the Resend Cognito Service
  CognitoResendCallback(message: string, result: any) {
    if (message != null) { // error
      this.invalidValidationMsg = message;
    } else { // success
      this.translate.get('Register.SuccessfullyResendCode').subscribe(error => {
        this.invalidValidationMsg = error;
      });
      // this.invalidValidationMsg = 'Successfully Resend Code';
    }
  }

  // Move By tag Click
  moveTags(tagname: string): void {
    switch (tagname) {
      case 'isFirstStep':
        if (!this.isfifthStep) {
          this.isFirstStep = true;
          this.isSecondStep = false;
          this.isThirdStep = false;
          this.isFourthStep = false;
          this.isfifthStep = false;
        }
        break;
      case 'isSecondStep':
         if (this.isValidationFirst && !this.isfifthStep) {
          this.isFirstStep = false;
          this.isSecondStep = true;
          this.isThirdStep = false;
          this.isFourthStep = false;
          this.isfifthStep = false;
        }
        break;
      case 'isThirdStep':
        if ((this.isValidationFirst && this.isValidationSecond) && !this.isfifthStep) {
          this.isFirstStep = false;
          this.isSecondStep = false;
          this.isThirdStep = true;
          this.isFourthStep = false;
          this.isfifthStep = false;
        }
        break;
      case 'isFourthStep':
      if ((this.isValidationFirst && this.isValidationSecond ) && this.isValidationThird && !this.isfifthStep) {
        this.isFirstStep = false;
        this.isSecondStep = false;
        this.isThirdStep = false;
        this.isFourthStep = true;
        this.isfifthStep = false;
      }
        break;
      case 'isfifthStep':
      if ((this.isValidationFirst && this.isValidationSecond ) && (this.isValidationThird && this.isValidationFourth)) {
        this.isFirstStep = false;
        this.isSecondStep = false;
        this.isThirdStep = false;
        this.isFourthStep = false;
        this.isfifthStep = true;
      }
        break;
    }

  }

  // Go to Login
  goToLogin(): void {
    this.router.navigate(['/login']);
  }



}



// WEBPACK FOOTER //
// ./src/app/authentication/register/register.component.ts